import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'type',
  pure: false
})
export class FilterGeneralPipe implements PipeTransform {

    constructor(private translate: TranslateService){}

    transform(value: any, modulo: string) {
        if (value || value === false) {
            switch (modulo) {
                case 'capitalize':
                    return value.substring(0, 1).toUpperCase() + value.substring(1);
                case 'date':
                    return moment.utc(value).format('DD/MM/YYYY');
                case 'condition':
                    return (value) ? 
                    this.translate.instant('button.yes') : this.translate.instant('button.no');
                case 'listArray':
                    const values = [];
                    value.map((element) => {
                        element.map((data) => {
                            values.push(data);
                        });
                    });
                    return values;
            }
        }
        return '';
    }
}
